import { Suspense } from 'react'
import { useActionData, useNavigation, useParams, useRouteLoaderData, Link, Await, Form } from 'react-router-dom';
import AdminPlatformPoliciesForm from '../../components/admin/AdminPlatformPoliciesForm.jsx'
import AdminPlatformPoliciesShow from '../../components/admin/AdminPlatformPoliciesShow.jsx'
import { GetPlatformPolicy, UpdatePlatformPolicy } from "../../repo/PlatformPoliciesRepo.js";
import { GetTournament } from "../../repo/TournamentsRepo.js"

export default function PlatformPolicyEditPage() {
  const {tournamentId} = useParams()
  const response = useActionData()
  const platformPolicyRelations = useRouteLoaderData('admin-platform-policy-edit')
  const createNavigation = useNavigation()
  const isSubmitting = createNavigation.state === 'submitting'

  return (
    <section className="m-8">
      {response && response.status && response.status  ? (
        <AdminPlatformPoliciesShow platformPolicy={platformPolicyRelations.platformPolicy} tournament={platformPolicyRelations.tournament} status="updated"/>
      ) : (
        <>
          <h1>Edit Platform Policy</h1>
          <div id="platform-policy-create-form" className={`w-full py-4 mb-4'`}>
            <Form method="PUT" className="space-y-4 md:space-y-6 mt-4">
              <Suspense fallback={<p>Carregando...</p>}>
                <Await resolve={platformPolicyRelations}>
                  {(loadedPlatformPolicyRelations) => <AdminPlatformPoliciesForm platformPolicy={loadedPlatformPolicyRelations.platformPolicy} tournament={loadedPlatformPolicyRelations.tournament} errors={(response && response.errors) ? response.errors : null } isSubmitting={isSubmitting}/>}
                </Await>
              </Suspense>
            </Form>
          </div>

          <div id="matches" className={`w-full pt-4 mt-4'`}>
            <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${tournamentId}/platform-policies`}>Back to Platform Policies</Link>
          </div>
        </>
      )}
    </section>
  )
}

export async function action({request}) {
  const data = await request.formData()

  const platformPolicyData = {
    platform_name: data.get('platform_name'),
    restriction: data.get('restriction'),
    tournament_id: data.get('tournament_id'),
    description: data.get('description')
  }

  return UpdatePlatformPolicy(data.get('id'), platformPolicyData)
}

export async function loader({ params, request }) {
  return {
    platformPolicy: (await GetPlatformPolicy(params.tournamentId, params.id)).data,
    tournament: await GetTournament(params.tournamentId)
  }
}
